import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';

/**
 * Section 14 — Debts
 */
export default function StepDebts({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  const fields = [
    { key: 'credit_cards', label: 'Credit Card(s)' },
    { key: 'home_equity_line_of_credit', label: 'Home Equity or Personal Line(s) of Credit' },
    { key: 'student_loans', label: 'Student Loan(s)' },
    { key: 'other_debts', label: 'Other Debts' },
  ];

  const total = fields.reduce(
    (sum, f) => sum + (Number(data[f.key]) || 0),
    0
  );

  return (
    <div>
      <SectionHeader
        number={14}
        title="Debts"
        tip="Enter the annual payment amount, not the outstanding balance.
          Auto loan payments belong in Auto & Transport. Mortgage payments
          belong in Housing. Be careful not to double-count credit card
          payments — if you pay groceries with a card, enter it in one place
          only."
      />

      <div className="alert alert-light border small mb-4">
        <strong>Note:</strong> Auto Payments → Auto & Transport |
        Mortgage → Housing
      </div>

      <div className="alert alert-warning d-flex align-items-start gap-3 mb-4">
        <span style={{ fontSize: '2rem', lineHeight: 1 }}>💡</span>
        <span>
          <strong>Enter your annual payment amount — not your outstanding balance.</strong>
          {' '}Take your typical monthly payment and multiply by 12. Use whichever applies to you:
          <ul className="mb-0 mt-1">
            <li><strong>Minimum payment</strong> — if you only pay the required minimum each month</li>
            <li><strong>Average monthly payment</strong> — if your payment varies month to month</li>
            <li><strong>Full balance paid monthly</strong> — if you pay the card off in full, enter your average monthly spend × 12 (but only what isn't already captured in another category above)</li>
          </ul>
        </span>
      </div>

      <div className="cashflow-field-grid">
        {fields.map(({ key, label }) => (
          <CurrencyInput
            key={key}
            id={key}
            label={label}
            value={data[key] ?? null}
            onChange={(val) => set(key, val)}
          />
        ))}
      </div>

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">14: Total Debts</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
